"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../../../comps/reusables");
const react_use_1 = require("react-use");
const hooks_1 = require("../../../../../../hooks");
const CODE_EDITOR_HEIGHT = 400;
exports.TestPushContentModal = ({ isOpen, close, contentFeedId, showContentItemsPanel, }) => {
    var _a;
    const [val, setVal] = react_use_1.useLocalStorage(window.location.href, '');
    const [showSuccessModal, toggleSuccessModal] = react_use_1.useToggle(false);
    const { sendTestContentPush, testContentPushResult } = hooks_1.useTestContentPush({
        onCompleted: () => {
            toggleSuccessModal(true);
        },
        variables: {
            data: val,
            id: contentFeedId,
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysModal, { isOpen: isOpen, toggle: close },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: close }, "Test content push"),
            react_1.default.createElement(reactstrap_1.ModalBody, { className: "p-0 m-0" },
                react_1.default.createElement(react_2.OsmosysDiv, { style: { height: CODE_EDITOR_HEIGHT } },
                    react_1.default.createElement(reusables_1.CodeEditor, { value: val, onChange: newVal => {
                            setVal(newVal);
                        }, maxHeight: CODE_EDITOR_HEIGHT }))),
            react_1.default.createElement(reactstrap_1.ModalFooter, null,
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "sendTest", mutate: sendTestContentPush, mutationResult: testContentPushResult, renderApolloError: true }, "Send test"))),
        react_1.default.createElement(react_2.OsmosysModal, { isOpen: showSuccessModal, toggle: toggleSuccessModal },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: toggleSuccessModal },
                react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "success" }),
                " Test successfully sent"),
            react_1.default.createElement(reactstrap_1.ModalBody, { toggle: toggleSuccessModal },
                react_1.default.createElement(react_2.OsmosysDiv, { style: { height: CODE_EDITOR_HEIGHT } },
                    react_1.default.createElement(reusables_1.CodeEditor, { value: (_a = testContentPushResult.data) === null || _a === void 0 ? void 0 : _a.sendTestContentPush, readOnly: true, onChange: () => { }, maxHeight: CODE_EDITOR_HEIGHT }))),
            react_1.default.createElement(reactstrap_1.ModalFooter, { className: "text-left" },
                react_1.default.createElement(react_2.OsmosysButton, { inline: true, osysName: "contentFeed.showContentItems", onClick: () => {
                        toggleSuccessModal(false);
                        close();
                        showContentItemsPanel();
                    }, osysIcon: "slot", color: "secondary" }, "Show content items"),
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "goBack", onClick: toggleSuccessModal }, "Go back")))));
};
//# sourceMappingURL=TestPushContentModalModal.js.map